/* RunAction.js */

"use strict";

const TRIGGER_TYPE_NAME_MAX_LENGTH = 60;
const TRIGGER_TYPE_NAME_LIST_LENGTH = 10;

class RunAction {
    constructor(logger, gameEditor, modalUserFeedback, activeView, userSession, TriggerTypeEntity) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._modalUserFeedback = modalUserFeedback;
        this._activeView = activeView;
        this._activeOrgId = userSession.activeOrganization.id;
        this._TriggerTypeEntity = TriggerTypeEntity;
        this._selectedTriggerTypeIds = [];
        this._selectedTriggerTypeNames = [];

        if (this._activeView && this._activeView.pagingFeed) {
            this._selectedTriggerTypeIds = this._activeView.getSelectedTriggerTypeIds().selectedRows || [];
        }

        let sort = (this._activeView && this._activeView.pagingFeed && this._activeView.pagingFeed.getSort()) || { name: 1 };
        this._selectedTriggerTypes = {
            sort: sort,
            ids: this._selectedTriggerTypeIds
        };

        this.run = this.run.bind(this);
    }

    run() {
        if (this._selectedTriggerTypeIds.length) {
            this._activeView.pagingFeed
                .waitForRangeIdsUpdated()
                .then(() => {
                    if (this._selectedTriggerTypeIds.length <= TRIGGER_TYPE_NAME_LIST_LENGTH) {
                        return this._activeView.pagingFeed.getTriggerTypeEntitiesNameById(this._selectedTriggerTypeIds);
                    }
                    return Promise.resolve();
                })
                .then((selectedTriggerTypeNames) => {
                    this._selectedTriggerTypeNames = selectedTriggerTypeNames;
                    if (this._selectedTriggerTypeIds.length <= TRIGGER_TYPE_NAME_LIST_LENGTH) {
                        if (Array.isArray(this._selectedTriggerTypeNames) && this._selectedTriggerTypeNames.length > 0) {
                            let s = this._selectedTriggerTypeNames.length > 1 ? "s" : "";
                            this._message =
                                "Are you sure you want to run the selected schedule" +
                                s +
                                "? This action will not impact future schedules from being run.\n";
                            Object.keys(this._selectedTriggerTypeNames).forEach((id) => {
                                let triggerTypeName = this._selectedTriggerTypeNames[id];
                                let shortTriggerTypeName =
                                    triggerTypeName.length > TRIGGER_TYPE_NAME_MAX_LENGTH
                                        ? triggerTypeName.substr(0, TRIGGER_TYPE_NAME_MAX_LENGTH) + "…"
                                        : triggerTypeName;
                                this._message += "\n" + shortTriggerTypeName;
                            });
                            return Promise.resolve();
                        } else {
                            return Promise.reject(new Error("Cannot retrieve the selected schedules"));
                        }
                    } else {
                        this._message = `Are you sure you want to run the selected ${this._selectedTriggerTypeIds.length} schedules now? This action will not impact future schedules from being run.\n`;
                        return Promise.resolve();
                    }
                })
                .then(() => {
                    return this._gameEditor.runQuickConfirmationActionWorkflow(
                        {
                            message: this._message,
                            title: "Run Now",
                            confirmDetails: {
                                text: "Confirm",
                                type: "additive"
                            },
                            rejectDetails: {
                                text: "Cancel",
                                type: "text"
                            }
                        },
                        () => {
                            return this._activeView.pagingFeed.getTriggerTypeEntitiesById(this._selectedTriggerTypes.ids).then((entities) => {
                                return Promise.all(entities.map((entity) => entity.runWorkNow()));
                            });
                        }
                    );
                })
                .catch((err) => {
                    this._logger.warn({ error: err }, "RunAction.run() - Error");
                    return this._modalUserFeedback.displayError({ error: { errorMsg: err } });
                });
        } else {
            return Promise.resolve();
        }
    }
}

module.exports = RunAction;

RunAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.ui.userFeedback",
    "gameEditor.activeView",
    "$teve.userSession",
    "$teve.entities.TriggerType"
];

RunAction.$displayDetails = {
    type: "Action",
    name: "RunAction",
    icon: "worktrigger.run",
    title: "Run Now",
    shown: true,
    order: 1
};
